var _circle, _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutubeIcon = function SvgYoutubeIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5879 15.1988C29.3574 14.342 28.6819 13.6667 27.8252 13.4359C26.2602 13.0076 19.9998 13.0076 19.9998 13.0076C19.9998 13.0076 13.7396 13.0076 12.1745 13.4196C11.3344 13.6502 10.6424 14.3422 10.4118 15.1988C10 16.7637 10 20.0092 10 20.0092C10 20.0092 10 23.2711 10.4118 24.8197C10.6425 25.6763 11.3179 26.3518 12.1747 26.5826C13.7561 27.0109 20 27.0109 20 27.0109C20 27.0109 26.2602 27.0109 27.8252 26.5989C28.682 26.3683 29.3574 25.6928 29.5881 24.8362C29.9999 23.2711 29.9999 20.0257 29.9999 20.0257C29.9999 20.0257 30.0164 16.7637 29.5879 15.1988Z",
    fill: "#312F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0066 23.0077L23.2124 20.0094L18.0066 17.011V23.0077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube_icon.fe5c6792.svg";
export { ForwardRef as ReactComponent };